import { render, staticRenderFns } from "./BlogComments.vue?vue&type=template&id=7621e97f&scoped=true"
import script from "./BlogComments.vue?vue&type=script&lang=js"
export * from "./BlogComments.vue?vue&type=script&lang=js"
import style0 from "./BlogComments.vue?vue&type=style&index=0&id=7621e97f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7621e97f",
  null
  
)

export default component.exports